import type { MailListItemMarkerProps } from './components/MailListItemMarker';
import type { MailListItemInfoProps } from './components/MailListItemInfo';
import type { MailListItemMeetingInfoProps } from './components/MailListItemMeetingInfo';
import type { MailListActionButtonProps } from './components/MailListActionButton';
import type { FolderTagProps } from './components/FolderTag';
import type { MailListItemTypePlaceholderProps } from './components/MailListItemTypePlaceholder';
import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyAction, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "MailListItemComponents"*/ './lazyIndex'),
    { name: 'MailListItemComponents' }
);

// components
export { default as MailListItemFirstLineText } from './components/MailListItemFirstLineText';
export { default as MailListItemIconBar } from './components/MailListItemIconBar';
export { default as MailListItemLabelsContainer } from './components/MailListItemLabelsContainer';
export { default as MailListItemLineText } from './components/MailListItemLineText';
export { default as MailListItemPreviewDisplay } from './components/MailListItemPreviewDisplay';
export { default as MailListItemRichPreviewWell } from './components/MailListItemRichPreviewWell';
export { default as MailListItemTimestamp } from './components/MailListItemTimestamp';
export { default as MailListItemTwistyButton } from './components/MailListItemTwistyButton';
export { default as MailListItemUnreadBar } from './components/MailListItemUnreadBar';
export { default as MailListItemUnreadCount } from './components/MailListItemUnreadCount';
export { default as PersonaCheckbox } from './components/PersonaCheckbox';
export { HoverIcon, PropertyIcon } from './components/IconBar';

// lazy components
export const MailListItemTypePlaceholder: LazyComponent<
    MailListItemTypePlaceholderProps,
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.MailListItemTypePlaceholder);
export const FolderTag: LazyComponent<FolderTagProps, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.FolderTag
);
export const MailListActionButton: LazyComponent<MailListActionButtonProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.MailListActionButton);
export const MailListItemMeetingInfo: LazyComponent<MailListItemMeetingInfoProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.MailListItemMeetingInfo);
export const MailListItemInfo: LazyComponent<MailListItemInfoProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.MailListItemInfo);

export const MailListItemMarker: LazyComponent<MailListItemMarkerProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.MailListItemMarker);

export const lazyGetFlagContextMenu: LazyAction<
    typeof lazyIndex.getFlagContextMenu,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getFlagContextMenu);
